/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Stuck_BodyInputs */

const en_help_stuck_body = /** @type {(inputs: Help_Stuck_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write to us and a person reads it. We usually answer within one working day.`)
};

const pl_help_stuck_body = /** @type {(inputs: Help_Stuck_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Napisz do nas, przeczyta to człowiek. Zwykle odpowiadamy w ciągu jednego dnia roboczego.`)
};

/**
* | output |
* | --- |
* | "Write to us and a person reads it. We usually answer within one working day." |
*
* @param {Help_Stuck_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const help_stuck_body = /** @type {((inputs?: Help_Stuck_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Stuck_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_help_stuck_body(inputs)
	return en_help_stuck_body(inputs)
});